import styled, { css } from "styled-components";
import { default as BaseImage } from "../../../common/Image";

export const Container = styled.div`
  height: 38.4rem;
  border-bottom: 0.1rem solid
    ${({ theme }) => theme.styleGuide.colors.gray[500]};
  background: ${({ theme }) => theme.styleGuide.colors.gray[500]} center center /
    cover no-repeat;
  position: relative;
  z-index: 503;

  ${({ theme }) => theme.media.sm`
    height: auto;
  `}

  .mapboxgl-ctrl.mapboxgl-ctrl-attrib {
    display: none;
  }
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  position: relative;
  z-index: 2;
`;

export const Content = styled.div`
  flex-grow: 1;
  width: 100%;
  height: 100%;
  max-width: 112.8rem;
  margin: 0 auto;
  padding: 0 6rem;
  transform: ${({ hasPhoto }) =>
    hasPhoto ? "translateY(0.8rem)" : "translateY(-1rem)"};

  ${({ theme }) => theme.media.sm`
    padding:  1.2rem 1.2rem 2.4rem;
    transform: none;
  `}
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ hasPhoto }) => !hasPhoto && "100%"};
  margin: -2.4rem;

  ${({ theme }) => theme.media.md`
    height: 100%;
  `}
`;

export const Cell = styled.div`
  padding: 2.4rem;

  &:first-child {
    flex-grow: 1;
  }

  &:last-child:not(:first-child) {
    flex-shrink: 0;

    ${({ theme }) => theme.media.md`
      display: none;
    `}
  }
`;

export const Title = styled.h1`
  font-weight: 600;
  margin-bottom: 2.4rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};

  ${({ theme }) => theme.media.sm`
    margin-bottom: 1.2rem;
  `}

  ${({ hasPhoto }) =>
    hasPhoto
      ? css`
          font-size: 3.6rem;
          line-height: 4.4rem;

          ${({ theme }) => theme.media.md`
            text-align: center;
          `}

          ${({ theme }) => theme.media.sm`
            font-size: 2.4rem;
            line-height: 2.9rem;
          `}
        `
      : css`
          font-size: 4.8rem;
          line-height: 5.2rem;
          text-align: center;

          ${({ theme }) => theme.media.sm`
            font-size: 3.2rem;
            line-height: 3.5rem;
          `}
        `}
`;

export const Address = styled.h2`
  font-weight: 600;
  margin-bottom: 2.4rem;
  color: ${({ theme }) => theme.live.colors.primary};

  ${({ theme }) => theme.media.sm`
    margin-bottom: 1.2rem;
  `}

  ${({ hasPhoto }) =>
    hasPhoto
      ? css`
          font-size: 2rem;
          line-height: 2.6rem;

          ${({ theme }) => theme.media.md`
            text-align: center;
          `}

          ${({ theme }) => theme.media.sm`
            font-size: 1.5rem;
            line-height: 1.8rem;
          `}
        `
      : css`
          font-size: 2.4rem;
          font-weight: 600;
          line-height: 3rem;
          margin-bottom: 2.4rem;
          text-align: center;

          ${({ theme }) => theme.media.sm`
            font-size: 1.6rem;
            line-height: 2rem;
          `}
        `}
`;

export const AddressDivider = styled.span`
  display: ${({ hasPhoto }) => hasPhoto && "none"};

  ${({ theme }) => theme.media.md`
    display: none;
  `}
`;

export const Street = styled.span`
  display: ${({ hasPhoto }) => hasPhoto && "block"};

  ${({ theme }) => theme.media.md`
    display: block;
  `}
`;

export const CityStateZip = styled.span`
  display: ${({ hasPhoto }) => hasPhoto && "block"};

  ${({ theme }) => theme.media.md`
    display: block;
  `}
`;

export const ClientDivider = styled.div`
  display: none;
  width: 28rem;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.live.colors.primary};
`;

export const Client = styled.h3`
  font-weight: 600;
  line-height: 2.2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};

  ${({ hasPhoto }) =>
    hasPhoto
      ? css`
          font-size: 1.6rem;
          line-height: 2.2rem;

          ${({ theme }) => theme.media.md`
            text-align: center;
          `}

          ${({ theme }) => theme.media.sm`
            font-size: 1.7rem;
            line-height: 2.4rem;
          `}
        `
      : css`
          font-size: 1.6rem;
          line-height: 2.2rem;
          text-align: center;

          ${({ theme }) => theme.media.sm`
            font-size: 1.7rem;
            line-height: 2.4rem;
          `}
        `}
`;

export const Image = styled(BaseImage)`
  width: 36.3rem;
  height: 24.4rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[400]};

  ${({ theme }) => theme.media.lg`
    width: 30rem;
  `}
`;
